@import '../../global/accessibility.css';

.breadcrumb {
    overflow: auto;
}

.breadcrumb__list {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    list-style: none;
    counter-reset: breadcrumb;
}

.breadcrumb__item {
    position: relative;
    flex: 1;
    text-align: center;
    padding: 4px;

    &--active {
        font-weight: 700;
    }

    &:after {
        content: "";
        display: block;
        width: 100%;
        height: 1px;

        position: absolute;
        @media #{$screen-min-sm} {
            top: 21px;
        }
        @media #{$screen-max-sm} {
            top: 11px;
        }
        left: 50%;
        border-bottom: 3px dotted #000;
    }

    &:last-child:after {
        content: none;
    }

    &.breadcrumb__item--completed {
        &:after {
            border-bottom-style: solid;
            border-bottom-width: 2px;
        }
    }

    a {
        text-decoration: none;
        color: currentColor;
        display: block;
    }
}

.breadcrumb__item-counter {
    position: relative;
    display: block;
    @media #{$screen-min-sm} {
        width: 40px;
        height: 40px;
    }
    @media #{$screen-max-sm} {
        width: 20px;
        height: 20px;
        font-size: 0px;
    }
    color: #000;
    //border: 1px solid currentColor;
    border-radius: 50%;
    background: #dce1e6;
    text-align: center;
    line-height: 40px;
    margin: 0 auto 10px;
    z-index: 1;


    &::before {
        position: relative;
        counter-increment: breadcrumb;
        content: counters(breadcrumb, ".");
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: 1;

        .breadcrumb__item--completed & {
            content: "";
            color: white;
            background: $color-success;
            background-image: var(--asset-url-icon-icon-check-svg);
            background-size: 60% 60%;
            background-position: 50% 50%;
            background-repeat: no-repeat;
        }

        .breadcrumb__item--active & {
            background: #fff;
        }
    }

    &::after {
        .breadcrumb__item--completed &,
        .breadcrumb__item--active & {
            content: "";
            display: block;
            width: calc(100% + 0.125rem);
            height: calc(100% + 0.125rem);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            background: #f5f5f5;
        }

        .breadcrumb__item--completed & {
            border: 1px solid $color-success;

        }

        .breadcrumb__item--active & {
            width: 100%;
            height: 100%;
            border: 2px solid $color-success;
        }
    }
}

.breadcrumb__item-text {
    display: block;

    @media #{$screen-max-sm} {
        margin-left: 6px;
        margin-right: 6px;
    }
}
